<div class="detail-oxxo-to-oxxo" *ngIf="this.from === 'general'">
	<div class="row">
		<div class="col-sm-10 col-md-10 col-lg-10 col-xl-10">
			<label class="header-user-detail">
				{{'orderDetail.title-orderDetail'|translate}}
			</label>
		</div>
		<div class="col-sm-2 col-md-2 col-lg-2 col-xl-2" (click)="closeModal()">
			<div class="closeIcon">
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-x-lg icon" viewBox="0 0 16 16">
					<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
				</svg>
			</div>
		</div>
		<div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
			<hr class="line">
		</div>
	</div>
	<div class="row">
		<div class="col-6">
			<div class="row" style="display: flex; row-gap: 12px;">
				<div class="col-3">
					<div [ngClass]="{'remitente-information-active': viewRemitenteInformation ===true, 'remitente-information-desactive': viewRemitenteInformation ===false}" (click)="ViewRemitenteInformation()">
						<label class="active">
							Remitente
						</label>
					</div>
				</div>
				<div class="col-3">
					<div [ngClass]="{'cedis-information-active': viewCedisInformation ===true, 'cedis-information-desactive': viewCedisInformation ===false}" (click)="ViewCedisInformation()">
						<label class="active">
							CEDIS
						</label>
					</div>
				</div>
				<div class="col-3">
					<div [ngClass]="{'destinatario-information-active': viewDestinatarioInformation ===true, 'destinatario-information-desactive': viewDestinatarioInformation ===false}" (click)="ViewDestinatarioInformation()">
						<label class="active">
							Destinatario
						</label>
					</div>
				</div>
				<div class="col-12">
					<div class="remitente-information-table" *ngIf="viewRemitenteInformation === true && viewCedisInformation === false && viewDestinatarioInformation === false">
						<div class="row" style="justify-content: center;">
							<div class="col-11">
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.trackingNumber' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											<!-- {{this.orderDetail..tracking_number}} -->
											{{this.orderDetail.data_package_service.tracking_number}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.originNumber' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetail.data_package_service.order_number}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.originLocker' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetail.data_locker.locker_source.locker_name}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.email' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">

											{{this.orderDetail.data_consumer.consumer_source.email}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.cellphone' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetail.data_consumer.consumer_source.main_tlf | phoneFormat}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.door' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">

										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.deliveryCategory' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetail.data_package_service.detail_package}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.valueProximate' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">

										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.planCoverage' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetail.data_package_service.insurance}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.scheduledDate' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetail.data_package_service.registration_date_schedule | dateFormatWithoutHour}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.maxRegisterDate' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetail.data_package_service.registration_date_in_locker | dateFormatWithoutHour}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.orderStatus' | translate}}
										</label>
									</div>
									<div class="table-item">
										<div class="text-response">
											<app-dialog-estatus-oxxo-to-oxxo [estatusID]="this.orderDetail.data_package_service.id_status">

											</app-dialog-estatus-oxxo-to-oxxo>
										</div>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.qualificationClient' | translate}}
										</label>
									</div>
									<div class="table-item">
										<div class="text-response">
											<app-star-rating starCount="5" [rating]="this.orderDetail.data_package_service.rate">

											</app-star-rating>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="cedis-information-table" *ngIf="viewRemitenteInformation === false && viewCedisInformation === true && viewDestinatarioInformation === false">
						<div class="row">
							<div class="col-12">
								<div class="table-contain">

								</div>
							</div>
						</div>
					</div>
					<div class="destinatario-information-table" *ngIf="viewRemitenteInformation === false && viewCedisInformation === false && viewDestinatarioInformation === true">
						<div class="row" style="justify-content: center;">
							<div class="col-11">
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.trackingNumber' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetail.data_package_service.tracking_number}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.destinyNumber' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetail.data_package_service.order_number}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.destinyLocker' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetail.data_locker.locker_destination.locker_name}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.email' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetail.data_consumer.consumer_destination.email}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.cellphone' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetail.data_consumer.consumer_destination.main_tlf | phoneFormat }}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.door' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">

										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.deliverDateDestiny' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											---
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.expirationDateDestiny' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											---
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.orderStatus' | translate}}
										</label>
									</div>
									<div class="table-item">
										<div class="text-response">
											<app-dialog-estatus-oxxo-to-oxxo [estatusID]="this.orderDetail.data_package_service.id_status">

											</app-dialog-estatus-oxxo-to-oxxo>
										</div>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.qualificationClient' | translate}}
										</label>
									</div>
									<div class="table-item">
										<div class="text-response">
											<app-star-rating starCount="5" [rating]="this.orderDetail.data_package_service.rate">

											</app-star-rating>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-6">
			<div class="row" >
				<div class="container-qr" *ngIf="viewRemitenteInformation === true && viewCedisInformation === false && viewDestinatarioInformation === false">
					<div class="box-qr">
						<div class="box-title">
							<label class="title">
								QR de entrega en origen
							</label>
							<app-button-icon [activo]="false" btnNombre="Descargar" btnType="primaryMedium" icon="icon-qr">

							</app-button-icon>
						</div>
						<div class="box-image-qr">
							<div class="border-box-image-qr">
								<div class="row" style="display: flex;
								justify-content: center;
								align-items: center;
								text-align: center;
								row-gap: 8px;">
									<div class="col-12">
										<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M9 12V9M9 6H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z" stroke="#4B4B4B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
									</div>
									<div class="col-12">
										<label class="label-text">
											Una vez el paquete este en ruta de entrega <br>
											el QR de recoleccion se generara
										</label>
									</div>
								</div>



							</div>
						</div>
					</div>
				</div>
				<div class="container-qr" *ngIf="viewRemitenteInformation === false && viewCedisInformation === true && viewDestinatarioInformation === false">
					<div class="box-qr">
						<div class="box-title">
							<label class="title">
								QR de entrega en origen
							</label>
							<app-button-icon [activo]="false" btnNombre="Descargar" btnType="primaryMedium" icon="icon-qr">

							</app-button-icon>
						</div>
						<div class="box-image-qr">
							<div class="border-box-image-qr-with-image">
								<svg width="284" height="297" viewBox="0 0 284 297" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<rect x="0.5" y="12.5" width="283" height="283" fill="url(#pattern0)"/>
									<defs>
										<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
										<use xlink:href="#image0_1719_58759" transform="translate(-0.141026 -0.141026) scale(0.0042735)"/>
										</pattern>
										<image id="image0_1719_58759" width="300" height="300" xlink:href="data:image/png;base64,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"/>
									</defs>
								</svg>
							</div>
						</div>
					</div>
				</div>
				<div class="container-qr" *ngIf="viewRemitenteInformation === false && viewCedisInformation === false && viewDestinatarioInformation === true">
					<div class="box-qr">
						<div class="box-title">
							<label class="title">
								QR de entrega en origen
							</label>
							<app-button-icon [activo]="false" btnNombre="Descargar" btnType="primaryMedium" icon="icon-qr">

							</app-button-icon>
						</div>
						<div class="box-image-qr">
							<div class="border-box-image-qr-with-image">
								<svg width="284" height="297" viewBox="0 0 284 297" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<rect x="0.5" y="12.5" width="283" height="283" fill="url(#pattern0)"/>
									<defs>
										<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
										<use xlink:href="#image0_1719_58759" transform="translate(-0.141026 -0.141026) scale(0.0042735)"/>
										</pattern>
										<image id="image0_1719_58759" width="300" height="300" xlink:href="data:image/png;base64,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"/>
									</defs>
								</svg>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="detail-oxxo-to-oxxo" *ngIf="this.from === 'scheduled'">
	<div class="row">
		<div class="col-sm-10 col-md-10 col-lg-10 col-xl-10">
			<label class="header-user-detail">
				{{'orderDetail.title-orderDetail'|translate}}
			</label>
		</div>
		<div class="col-sm-2 col-md-2 col-lg-2 col-xl-2" (click)="closeModal()">
			<div class="closeIcon">
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-x-lg icon" viewBox="0 0 16 16">
					<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
				</svg>
			</div>
		</div>
		<div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
			<hr class="line">
		</div>
	</div>
	<div class="row">
		<div class="col-6">
			<div class="row" style="display: flex; row-gap: 12px;">
				<div class="col-3">
					<div [ngClass]="{'remitente-information-active': viewRemitenteInformation ===true, 'remitente-information-desactive': viewRemitenteInformation ===false}" (click)="ViewRemitenteInformation()">
						<label class="active">
							Remitente
						</label>
					</div>
				</div>
				<div class="col-3">
					<div [ngClass]="{'cedis-information-active': viewCedisInformation ===true, 'cedis-information-desactive': viewCedisInformation ===false}" (click)="ViewCedisInformation()">
						<label class="active">
							CEDIS
						</label>
					</div>
				</div>
				<div class="col-3">
					<div [ngClass]="{'destinatario-information-active': viewDestinatarioInformation ===true, 'destinatario-information-desactive': viewDestinatarioInformation ===false}" (click)="ViewDestinatarioInformation()">
						<label class="active">
							Destinatario
						</label>
					</div>
				</div>
				<div class="col-12">
					<div class="remitente-information-table" *ngIf="viewRemitenteInformation === true && viewCedisInformation === false && viewDestinatarioInformation === false">
						<div class="row" style="justify-content: center;">
							<div class="col-11">
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.originNumber' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.scheduledDetail.data_package_service.number_orden}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.originLocker' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.scheduledDetail.data_locker.locker_source.locker_name}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.email' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.scheduledDetail.data_consumer.source_consumer.email_consumer}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.cellphone' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.scheduledDetail.data_consumer.source_consumer.main_tlf | phoneFormat}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.door' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.deliveryCategory' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response" *ngFor="let item of this.scheduledDetail.data_package_service.detail_package">
											{{item.description}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.valueProximate' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											${{this.scheduledDetail.data_package_service.approximate_value}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.planCoverage' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.scheduledDetail.insurance}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.scheduledDate' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.scheduledDetail.registration_date | dateFormatWithoutHour}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.maxRegisterDate' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.scheduledDetail.registration_date | dateFormatWithoutHour}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.orderStatus' | translate}}
										</label>
									</div>
									<div class="table-item">
										<div class="text-response">
											<app-dialog-estatus-oxxo-to-oxxo [estatusID]="this.scheduledDetail.id_status">
											</app-dialog-estatus-oxxo-to-oxxo>
										</div>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.qualificationClient' | translate}}
										</label>
									</div>
									<div class="table-item">
										<div class="text-response">
											<app-star-rating starCount="5" [rating]="0">
											</app-star-rating>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="cedis-information-table" *ngIf="viewRemitenteInformation === false && viewCedisInformation === true && viewDestinatarioInformation === false">
						<div class="row">
							<div class="col-12">
								<div class="table-contain">

								</div>
							</div>
						</div>
					</div>
					<div class="destinatario-information-table" *ngIf="viewRemitenteInformation === false && viewCedisInformation === false && viewDestinatarioInformation === true">
						<div class="row" style="justify-content: center;">
							<div class="col-11">
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.destinyNumber' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.scheduledDetail.data_package_service.number_orden}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.destinyLocker' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.scheduledDetail.data_locker.locker_destination.locker_name}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.email' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.scheduledDetail.data_consumer.destination_consumer.email_consumer}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.cellphone' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.scheduledDetail.data_consumer.destination_consumer.main_tlf | phoneFormat }}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.door' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">

										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.deliverDateDestiny' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											---
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.expirationDateDestiny' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											---
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.orderStatus' | translate}}
										</label>
									</div>
									<div class="table-item">
										<div class="text-response">
											<app-dialog-estatus-oxxo-to-oxxo [estatusID]="this.scheduledDetail.id_status">

											</app-dialog-estatus-oxxo-to-oxxo>
										</div>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.qualificationClient' | translate}}
										</label>
									</div>
									<div class="table-item">
										<div class="text-response">
											<app-star-rating starCount="5" [rating]="4">

											</app-star-rating>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-6">
			<div class="row" >
				<div class="container-qr" *ngIf="viewRemitenteInformation === true && viewCedisInformation === false && viewDestinatarioInformation === false">
					<div class="box-qr">
						<div class="box-title">
							<label class="title">
								QR de entrega en origen
							</label>
							<app-button-icon [activo]="false" btnNombre="Descargar" btnType="primaryMedium" icon="icon-qr">

							</app-button-icon>
						</div>
						<div class="box-image-qr">
							<div class="border-box-image-qr">
								<div class="row" style="display: flex;
								justify-content: center;
								align-items: center;
								text-align: center;
								row-gap: 8px;">
									<div class="col-12">
										<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M9 12V9M9 6H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z" stroke="#4B4B4B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
									</div>
									<div class="col-12">
										<label class="label-text">
											Una vez el paquete este en ruta de entrega <br>
											el QR de recoleccion se generara
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="container-qr" *ngIf="viewRemitenteInformation === false && viewCedisInformation === true && viewDestinatarioInformation === false">
					<div class="box-qr">
						<div class="box-title">
							<label class="title">
								QR de entrega en origen
							</label>
							<app-button-icon [activo]="false" btnNombre="Descargar" btnType="primaryMedium" icon="icon-qr">
							</app-button-icon>
						</div>
						<div class="box-image-qr">
							<div class="border-box-image-qr-with-image">
								<svg width="284" height="297" viewBox="0 0 284 297" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<rect x="0.5" y="12.5" width="283" height="283" fill="url(#pattern0)"/>
									<defs>
										<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
										<use xlink:href="#image0_1719_58759" transform="translate(-0.141026 -0.141026) scale(0.0042735)"/>
										</pattern>
										<image id="image0_1719_58759" width="300" height="300" xlink:href="data:image/png;base64,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"/>
									</defs>
								</svg>
							</div>
						</div>
					</div>
				</div>
				<div class="container-qr" *ngIf="viewRemitenteInformation === false && viewCedisInformation === false && viewDestinatarioInformation === true">
					<div class="box-qr">
						<div class="box-title">
							<label class="title">
								QR de entrega en origen
							</label>
							<app-button-icon [activo]="false" btnNombre="Descargar" btnType="primaryMedium" icon="icon-qr">

							</app-button-icon>
						</div>
						<div class="box-image-qr">
							<div class="border-box-image-qr-with-image">
								<svg width="284" height="297" viewBox="0 0 284 297" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<rect x="0.5" y="12.5" width="283" height="283" fill="url(#pattern0)"/>
									<defs>
										<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
										<use xlink:href="#image0_1719_58759" transform="translate(-0.141026 -0.141026) scale(0.0042735)"/>
										</pattern>
										<image id="image0_1719_58759" width="300" height="300" xlink:href="data:image/png;base64,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"/>
									</defs>
								</svg>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="detail-oxxo-to-oxxo" *ngIf="this.from === 'warehouse'">
	<div class="row">
		<div class="col-sm-10 col-md-10 col-lg-10 col-xl-10">
			<label class="header-user-detail">
				{{'orderDetail.title-orderDetail'|translate}}
			</label>
		</div>
		<div class="col-sm-2 col-md-2 col-lg-2 col-xl-2" (click)="closeModal()">
			<div class="closeIcon">
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-x-lg icon" viewBox="0 0 16 16">
					<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
				</svg>
			</div>
		</div>
		<div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
			<hr class="line">
		</div>
	</div>
	<div class="row">
		<div class="col-6">
			<div class="row" style="display: flex; row-gap: 12px;">
				<div class="col-3">
					<div [ngClass]="{'remitente-information-active': viewRemitenteInformation ===true, 'remitente-information-desactive': viewRemitenteInformation ===false}" (click)="ViewRemitenteInformation()">
						<label class="active">
							Remitente
						</label>
					</div>
				</div>
				<div class="col-3">
					<div [ngClass]="{'cedis-information-active': viewCedisInformation ===true, 'cedis-information-desactive': viewCedisInformation ===false}" (click)="ViewCedisInformation()">
						<label class="active">
							CEDIS
						</label>
					</div>
				</div>
				<div class="col-3">
					<div [ngClass]="{'destinatario-information-active': viewDestinatarioInformation ===true, 'destinatario-information-desactive': viewDestinatarioInformation ===false}" (click)="ViewDestinatarioInformation()">
						<label class="active">
							Destinatario
						</label>
					</div>
				</div>
				<div class="col-12">
					<div class="remitente-information-table" *ngIf="viewRemitenteInformation === true && viewCedisInformation === false && viewDestinatarioInformation === false">
						<div class="row" style="justify-content: center;">
							<div class="col-11">
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.trackingNumber' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											<!-- {{this.orderDetail..tracking_number}} -->
											{{this.orderDetailInTransint.data_package_service.tracking_number}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.originNumber' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetailInTransint.data_package_service.order_number}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.originLocker' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetailInTransint.data_locker.locker_source.locker_name}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.email' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">

											{{this.orderDetailInTransint.data_consumer.consumer_source.email}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.cellphone' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetailInTransint.data_consumer.consumer_source.main_tlf | phoneFormat}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.door' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">

										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.deliveryCategory' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetailInTransint.data_package_service.detail_package}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.valueProximate' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">

										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.planCoverage' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetailInTransint.data_package_service.insurance}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.scheduledDate' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetailInTransint.data_package_service.registration_date_schedule | dateFormatWithoutHour}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.maxRegisterDate' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetailInTransint.data_package_service.registration_date_in_locker | dateFormatWithoutHour}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.orderStatus' | translate}}
										</label>
									</div>
									<div class="table-item">
										<div class="text-response">
											<app-dialog-estatus-oxxo-to-oxxo [estatusID]="this.orderDetailInTransint.data_package_service.id_status">

											</app-dialog-estatus-oxxo-to-oxxo>
										</div>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.remitente.qualificationClient' | translate}}
										</label>
									</div>
									<div class="table-item">
										<div class="text-response">
											<app-star-rating starCount="5" [rating]="this.orderDetailInTransint.data_package_service.rate">

											</app-star-rating>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="cedis-information-table" *ngIf="viewRemitenteInformation === false && viewCedisInformation === true && viewDestinatarioInformation === false">
						<div class="row">
							<div class="col-12">
								<div class="table-contain">

								</div>
							</div>
						</div>
					</div>
					<div class="destinatario-information-table" *ngIf="viewRemitenteInformation === false && viewCedisInformation === false && viewDestinatarioInformation === true">
						<div class="row" style="justify-content: center;">
							<div class="col-11">
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.trackingNumber' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetailInTransint.data_package_service.tracking_number}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.destinyNumber' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetailInTransint.data_package_service.order_number}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.destinyLocker' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetailInTransint.data_locker.locker_destination.locker_name}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.email' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetailInTransint.data_consumer.consumer_destination.email}}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.cellphone' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											{{this.orderDetailInTransint.data_consumer.consumer_destination.main_tlf | phoneFormat }}
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.door' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">

										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.deliverDateDestiny' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											---
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.expirationDateDestiny' | translate}}
										</label>
									</div>
									<div class="table-item">
										<label for="" class="text-response">
											---
										</label>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.orderStatus' | translate}}
										</label>
									</div>
									<div class="table-item">
										<div class="text-response">
											<app-dialog-estatus-oxxo-to-oxxo [estatusID]="this.orderDetailInTransint.data_package_service.id_status">

											</app-dialog-estatus-oxxo-to-oxxo>
										</div>
									</div>
								</div>
								<div class="table-contain">
									<div class="table-item">
										<label class="text">
											{{'oxxoToOxxo.dialog.destinatario.qualificationClient' | translate}}
										</label>
									</div>
									<div class="table-item">
										<div class="text-response">
											<app-star-rating starCount="5" [rating]="this.orderDetailInTransint.data_package_service.rate">

											</app-star-rating>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-6">
			<div class="row" >
				<div class="container-qr" *ngIf="viewRemitenteInformation === true && viewCedisInformation === false && viewDestinatarioInformation === false">
					<div class="box-qr">
						<div class="box-title">
							<label class="title">
								QR de entrega en origen
							</label>
							<app-button-icon [activo]="false" btnNombre="Descargar" btnType="primaryMedium" icon="icon-qr">

							</app-button-icon>
						</div>
						<div class="box-image-qr">
							<div class="border-box-image-qr">
								<div class="row" style="display: flex;
								justify-content: center;
								align-items: center;
								text-align: center;
								row-gap: 8px;">
									<div class="col-12">
										<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M9 12V9M9 6H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z" stroke="#4B4B4B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
									</div>
									<div class="col-12">
										<label class="label-text">
											Una vez el paquete este en ruta de entrega <br>
											el QR de recoleccion se generara
										</label>
									</div>
								</div>



							</div>
						</div>
					</div>
				</div>
				<div class="container-qr" *ngIf="viewRemitenteInformation === false && viewCedisInformation === true && viewDestinatarioInformation === false">
					<div class="box-qr">
						<div class="box-title">
							<label class="title">
								QR de entrega en origen
							</label>
							<app-button-icon [activo]="false" btnNombre="Descargar" btnType="primaryMedium" icon="icon-qr">

							</app-button-icon>
						</div>
						<div class="box-image-qr">
							<div class="border-box-image-qr-with-image">
								<svg width="284" height="297" viewBox="0 0 284 297" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<rect x="0.5" y="12.5" width="283" height="283" fill="url(#pattern0)"/>
									<defs>
										<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
										<use xlink:href="#image0_1719_58759" transform="translate(-0.141026 -0.141026) scale(0.0042735)"/>
										</pattern>
										<image id="image0_1719_58759" width="300" height="300" xlink:href="data:image/png;base64,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"/>
									</defs>
								</svg>
							</div>
						</div>
					</div>
				</div>
				<div class="container-qr" *ngIf="viewRemitenteInformation === false && viewCedisInformation === false && viewDestinatarioInformation === true">
					<div class="box-qr">
						<div class="box-title">
							<label class="title">
								QR de entrega en origen
							</label>
							<app-button-icon [activo]="false" btnNombre="Descargar" btnType="primaryMedium" icon="icon-qr">

							</app-button-icon>
						</div>
						<div class="box-image-qr">
							<div class="border-box-image-qr-with-image">
								<svg width="284" height="297" viewBox="0 0 284 297" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<rect x="0.5" y="12.5" width="283" height="283" fill="url(#pattern0)"/>
									<defs>
										<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
										<use xlink:href="#image0_1719_58759" transform="translate(-0.141026 -0.141026) scale(0.0042735)"/>
										</pattern>
										<image id="image0_1719_58759" width="300" height="300" xlink:href="data:image/png;base64,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"/>
									</defs>
								</svg>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
